const hogwartsQuizQuestions = [
  {
    question: "What is Hogwarts' motto?",
    answers: [
      { answer: "Draco Mal Dormiens Tilandum", isCorrect: false },
      { answer: "Never Tickle a Sleeping Dragon", isCorrect: true },
      { answer: "Draco Dormiens Nunca Titillandus", isCorrect: false },
      { answer: "Never believe false rumors", isCorrect: false }
    ]
  },
  {
    question: "How many floors does Hogwarts have?",
    answers: [
      { answer: "8", isCorrect: true },
      { answer: "19", isCorrect: false },
      { answer: "5", isCorrect: false },
      { answer: "22", isCorrect: false }
    ]
  },
  {
    question: "When is the first day of classes every year?",
    answers: [
      { answer: "August 28", isCorrect: false },
      { answer: "The first Monday in September", isCorrect: false },
      { answer: "The last Monday in August", isCorrect: false },
      { answer: "September 1", isCorrect: true },
    ]
  },
  {
    question: "Who was one of the founder of Hogwarts?",
    answers: [
      { answer: "Gildeon Gryffindor", isCorrect: false },
      { answer: "Salazar Slytherin", isCorrect: true },
      { answer: "Roland Ravenclaw", isCorrect: false },
      { answer: "Harold Hufflepuff", isCorrect: false }
    ]
  },
  {
    question: "Complete the Sorting Hat song: 'We'll teach all those with brave deeds to their name.' ",
    answers: [
      { answer: "We'll teach those who will bring our school much fame.", isCorrect: false },
      { answer: "We'll teach those who can quickly pass a game.", isCorrect: false },
      { answer: "We'll teach the lot and treat them just the same.", isCorrect: true },
      { answer: "We'll teach those who won't bring us any shame.", isCorrect: false }
    ]
  },

]

export default hogwartsQuizQuestions
